import { AbstractCommand } from 'src/models/command';

class ArchiveTheSelectedAggregateIdsCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_ArchiveTheSelectedAggregateIds';
	readonly processId = 'random';

	public constructor(aggregateIds: string[]) {
		super();
		this.parameters = {
			aggregateIds: aggregateIds,
		};
	}
}

export { ArchiveTheSelectedAggregateIdsCommand };
